// Modul zur Erfassung von Zuschüssen analaog Finanzierungen
"use strict";

import module from "./module.js";

export default module;
